import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import ViewController from "./ViewController";
import EditController from "./EditController";
import TagsController from "./TagsController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('customer', {
                url: '/customer',
                abstract: true,
            })
            .state('customer.view', {
                url: '/{customerGuid}/view?tab',
                params: {
                    tab: {dynamic: true},
                },
                template: require('./View.html'),
                controller: ViewController,
                controllerAs: 'vm',
                data: {title: 'Customer'}
            })
            .state('customer.edit', {
                url: '/{customerGuid}/edit',
                template: require('./Edit.html'),
                controller: EditController,
                controllerAs: 'vm',
                data: {title: 'Edit Customer'}
            })
            .state('customer.new', {
                url: '/new?lead',
                template: require('./Edit.html'),
                controller: EditController,
                controllerAs: 'vm',
                data: {title: 'Add New Customer'}
            })
            .state('customer.tags', {
                url: '/tags',
                template: require('./Tags.html'),
                controller: TagsController,
                controllerAs: 'vm',
                data: {title: 'Customer Tags'}
            })


    }
}

export default angular.module('app.customer', [])
    .config(Routes)
    .name;
